// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchable-select-wrapper {
  position: relative;
  width: 100%;
}

/* 主输入框容器 */
.searchable-select-input-wrapper {
  position: relative;
  width: 100%;
}

/* 主输入框 - 模仿 select 的样式 */
.searchable-select-main-input {
  width: 100%;
  padding: 10px 36px 10px 12px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.searchable-select-main-input:hover {
  border-color: #9CA3AF;
}

.searchable-select-main-input.open {
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  cursor: text;
}

.searchable-select-main-input::placeholder {
  color: #9CA3AF;
}

/* 当只显示 placeholder 时，保持灰色 */
.searchable-select-main-input.placeholder-only {
  color: #9CA3AF;
}

/* 下拉箭头 */
.searchable-select-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6B7280;
  font-size: 10px;
  pointer-events: none;
  transition: transform 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.searchable-select-arrow.open {
  transform: translateY(-50%) rotate(180deg);
}

/* 下拉选项容器 */
.searchable-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 2px solid #3B82F6;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 99999;
  max-height: 320px;
  display: flex;
  flex-direction: column;
  animation: slideDown 0.15s ease;
  overflow: hidden;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.searchable-select-options {
  overflow-y: auto;
  max-height: 320px;
  padding: 8px;
}

.searchable-select-options::-webkit-scrollbar {
  width: 8px;
}

.searchable-select-options::-webkit-scrollbar-track {
  background: #F3F4F6;
  border-radius: 4px;
  margin: 4px;
}

.searchable-select-options::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 4px;
}

.searchable-select-options::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

.searchable-select-option {
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  transition: all 0.15s ease;
  margin-bottom: 4px;
  -webkit-user-select: none;
          user-select: none;
}

.searchable-select-option:hover,
.searchable-select-option.highlighted {
  background-color: #EEF2FF;
  color: #3B82F6;
}

.searchable-select-option.selected {
  background-color: #3B82F6;
  color: white;
  font-weight: 500;
}

.searchable-select-option.selected:hover {
  background-color: #2563EB;
}

.searchable-select-option.no-results {
  text-align: center;
  color: #9CA3AF;
  font-style: italic;
  cursor: default;
  padding: 20px 12px;
}

.searchable-select-option.no-results:hover {
  background-color: transparent;
  color: #9CA3AF;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchableSelect/SearchableSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB","sourcesContent":[".searchable-select-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n/* 主输入框容器 */\n.searchable-select-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n/* 主输入框 - 模仿 select 的样式 */\n.searchable-select-main-input {\n  width: 100%;\n  padding: 10px 36px 10px 12px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  border: 2px solid #E5E7EB;\n  border-radius: 8px;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.searchable-select-main-input:hover {\n  border-color: #9CA3AF;\n}\n\n.searchable-select-main-input.open {\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  cursor: text;\n}\n\n.searchable-select-main-input::placeholder {\n  color: #9CA3AF;\n}\n\n/* 当只显示 placeholder 时，保持灰色 */\n.searchable-select-main-input.placeholder-only {\n  color: #9CA3AF;\n}\n\n/* 下拉箭头 */\n.searchable-select-arrow {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6B7280;\n  font-size: 10px;\n  pointer-events: none;\n  transition: transform 0.2s ease;\n  user-select: none;\n}\n\n.searchable-select-arrow.open {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n/* 下拉选项容器 */\n.searchable-select-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: white;\n  border: 2px solid #3B82F6;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  z-index: 99999;\n  max-height: 320px;\n  display: flex;\n  flex-direction: column;\n  animation: slideDown 0.15s ease;\n  overflow: hidden;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.searchable-select-options {\n  overflow-y: auto;\n  max-height: 320px;\n  padding: 8px;\n}\n\n.searchable-select-options::-webkit-scrollbar {\n  width: 8px;\n}\n\n.searchable-select-options::-webkit-scrollbar-track {\n  background: #F3F4F6;\n  border-radius: 4px;\n  margin: 4px;\n}\n\n.searchable-select-options::-webkit-scrollbar-thumb {\n  background: #D1D5DB;\n  border-radius: 4px;\n}\n\n.searchable-select-options::-webkit-scrollbar-thumb:hover {\n  background: #9CA3AF;\n}\n\n.searchable-select-option {\n  padding: 10px 12px;\n  cursor: pointer;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #374151;\n  transition: all 0.15s ease;\n  margin-bottom: 4px;\n  user-select: none;\n}\n\n.searchable-select-option:hover,\n.searchable-select-option.highlighted {\n  background-color: #EEF2FF;\n  color: #3B82F6;\n}\n\n.searchable-select-option.selected {\n  background-color: #3B82F6;\n  color: white;\n  font-weight: 500;\n}\n\n.searchable-select-option.selected:hover {\n  background-color: #2563EB;\n}\n\n.searchable-select-option.no-results {\n  text-align: center;\n  color: #9CA3AF;\n  font-style: italic;\n  cursor: default;\n  padding: 20px 12px;\n}\n\n.searchable-select-option.no-results:hover {\n  background-color: transparent;\n  color: #9CA3AF;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
